import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { useWorkspace } from '../../context/WorkspaceContext';

// Buttons (not links) so they don't inflate the gallery's link counts in tests.
// All add-affordances render nothing for viewers of a shared move (no canEdit).

/** Dashed "add another" card that always trails the gallery grid (cards view). */
export function AddItemTile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { canEdit } = useWorkspace();
  if (!canEdit) return null;
  return (
    <button
      type="button"
      onClick={() => navigate('/app/items/new')}
      aria-label={t('gallery.addItem')}
      className="group flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-petrol/40 bg-petrol-tint/40 text-petrol min-h-[160px] hover:border-petrol hover:bg-petrol-tint transition-colors"
    >
      <span className="size-11 rounded-full bg-petrol text-white flex items-center justify-center shadow-card group-hover:scale-105 transition-transform">
        <Plus className="size-6" />
      </span>
      <span className="text-[14px] font-medium">{t('gallery.addItem')}</span>
    </button>
  );
}

/** Dashed full-width "add another" bar (use anywhere — lists, stacks). */
export function AddItemBar() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { canEdit } = useWorkspace();
  if (!canEdit) return null;
  return (
    <button
      type="button"
      onClick={() => navigate('/app/items/new')}
      aria-label={t('gallery.addItem')}
      className="w-full flex items-center justify-center gap-2 py-4 rounded-xl border-2 border-dashed border-petrol/40 text-petrol hover:border-petrol hover:bg-petrol-tint/50 transition-colors"
    >
      <span className="size-7 rounded-full bg-petrol text-white flex items-center justify-center">
        <Plus className="size-4" />
      </span>
      <span className="text-[15px] font-medium">{t('gallery.addItem')}</span>
    </button>
  );
}

/** Same bar wrapped as an <li> for the gallery list <ul>. */
export function AddItemRow() {
  const { canEdit } = useWorkspace();
  if (!canEdit) return null; // avoid an empty <li> for viewers
  return (
    <li>
      <AddItemBar />
    </li>
  );
}
